import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { venueCreateShopifyStoreConnectionApi } from '../../../api/shopify/venueCreateShopifyStoreConnectionApi';

type Props = {
  onSuccess?: () => void;
};

export const useVenueCreateShopifyConnectionMutation = ({ onSuccess }: Props) => {
  const { enqueueSnackbar } = useSnackbar();

  const mutation = useMutation({
    mutationFn: venueCreateShopifyStoreConnectionApi,
    onSettled: () => {
      if (onSuccess) onSuccess();
      enqueueSnackbar('Connection created successfully.', { variant: 'success' });
    },
    onError: () => {
      enqueueSnackbar('Something went wrong while deleting the message', { variant: 'error' });
    },
  });

  return mutation;
};
